import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IImportAnnotationsStore } from '../../../../importAnnotations.store';
import { ImportSummaryPane } from './ImportSummaryPane';

export const ImportSummaryPaneContainer = observer((): ReactElement => {
  const store = useInjection(IImportAnnotationsStore.$);

  if (!store.report) {
    return <></>;
  }

  return (
    <ImportSummaryPane
      importedItemsCount={store.report.importedAnnotationsCount}
      skippedItemsCount={store.report.skippedAnnotationsCount}
      rejectedAnnotations={store.report.rejectedAnnotations}
    />
  );
});
